import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';

interface HelpSupportTabsProps {
  value: number;
  onChange: (value: number) => void;
}

export const HelpSupportTabs: React.FC<HelpSupportTabsProps> = ({ value, onChange }) => {
  return (
    <Box sx={{ borderBottom: '1px solid #e8e8ee' }}>
      <Tabs
        value={value}
        onChange={(_, newValue: number) => onChange(newValue)}
        sx={{
          minHeight: 0,
          '& .MuiTabs-indicator': {
            height: '2px',
            backgroundColor: '#20aedc',
          },
          '& .MuiTab-root': {
            minHeight: 0,
            py: 1.5,
            px: 0,
            mr: 5,
            textTransform: 'none',
            fontSize: 16,
            color: '#717182',
          },
          '& .MuiTab-root.Mui-selected': {
            color: '#20aedc',
            fontWeight: 500,
          },
        }}
      >
        <Tab label="Product Guide" />
        <Tab label="Support" />
      </Tabs>
    </Box>
  );
};
